// extracted by css-extract-rspack-plugin
export default {"cls1":"useFirstSuggestedWorkToast-cls1_oa2","cls2":"useFirstSuggestedWorkToast-cls2_mZN useFirstSuggestedWorkToast-cls1_oa2"};